import 'angular';

import { downgradeComponent } from '@angular/upgrade/static';

import { ChangeVendorLiteCtrl }         from './vendor.change';
import { LinkedVendorsLiteCtrl }        from './vendors.linked-vendors';
import { ManuallyLinkVendorLiteCtrl }   from './vendor.manually-link';
import { ResolveVendorMatchesLiteCtrl } from './vendor.resolve-matches';
import { VendorActivityLogsComponent }  from './vendor.activity-logs.component';
import { VendorLiteCtrl }               from './vendor';
import { VendorQuickAddLiteCtrl }       from './vendor.quick-add';
import { VendorSelectionLiteCtrl }      from './vendor.selection';
import { VendorServiceLite }            from './vendor.service';

angular.module('app-lite.vendors', [])
  .controller('ChangeVendorLiteCtrl', ChangeVendorLiteCtrl)
  .controller('LinkedVendorsLiteCtrl', LinkedVendorsLiteCtrl)
  .controller('ManuallyLinkVendorLiteCtrl', ManuallyLinkVendorLiteCtrl)
  .controller('ResolveVendorMatchesLiteCtrl', ResolveVendorMatchesLiteCtrl)
  .controller('VendorQuickAddLiteCtrl', VendorQuickAddLiteCtrl)
  .controller('VendorSelectionLiteCtrl', VendorSelectionLiteCtrl)
  .controller('VendorLiteCtrl', VendorLiteCtrl)
  .directive('worVendorActivityLogs', downgradeComponent({ component: VendorActivityLogsComponent }))
  .factory('VendorLite', VendorServiceLite);